export const environment = {
  production: false,
//  apiUrl: 'https://webshop.grawe.rs/api/api/',
  fileUrl: 'https://webshop.grawe.rs/api/files/',
// apiUrl: 'http://webshoptest-api.azurewebsites.net/api/',
 apiUrl: 'http://localhost:64610/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts